import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { CoachingService } from "../service/coaching.service";

@Injectable()
export class CanActivateCoach implements CanActivate {

    private hasSaisieCoach = null;

    constructor(private coachingService: CoachingService){   
    }

    canActivate() {
        if (this.hasSaisieCoach === null) {
            this.hasSaisieCoach = this.coachingService.hasSaisieCoach();
        }
        return this.hasSaisieCoach;
    }

}


// WEBPACK FOOTER //
// ./src/app/guard/coach-guard.service.ts